/** Created by azhou on 2018/11/30.*/
<template>
  <div :id="mountId"></div>
</template>

<script>
  // 引入 ECharts 主模块
  const echarts = require('echarts/lib/echarts')
  // 引入提示框和标题组件
  require('echarts/lib/component/tooltip')
  require('echarts/lib/component/title')
  export default {
    props: {
      mountId: {
        type: String,
        default: 'e-bar'
      },
      DataSet: {     //数据集合
        type: Array,
        default () {
          return []
        }
      },
      xAxisSet: {     //X轴数据集合
        type: Array,
        default () {
          return []
        }
      },
      chartTitle: {
        type: String,
        default: '订单总数统计数据'
      }
    },
    data () {
      return {
        myChart: null,
        option: null
      }
    },
    mounted () {
      $('#' + this.mountId).css({
        height: $('.e-data').height() * 0.6 + 'px',
      })
      this.initEchart()
    },
    watch: {
      DataSet () {
        this.initEchart()
      }
    },
    methods: {
      /*初始化echart图表*/
      initEchart () {
        // 基于准备好的dom，初始化echarts实例
        this.myChart = echarts.init($('#' + this.mountId).get(0))
        let option = {
          title: {
            text: this.chartTitle,
            left: 'center',
            textStyle: {
              color: '#eee',
              fontSize: '16px'
            }
          },
          legend: {
            orient: 'horizontal',
            top: 'top',
            left: 'left',
            data: this.DataSet.map(item => item.name),
            textStyle: { color: '#eee' }
          },
          tooltip: {
            trigger: 'axis',
            axisPointer: {
              type: 'shadow'
            }
          },
          toolbox: {
            show: true,
            right: '40px',
            feature: {
              restore: { show: true },
              dataZoom: { show: true },
              magicType: { type: ['line', 'bar'] }
            }
          },
          xAxis: {
            type: 'category',
            axisLine: {
              lineStyle: {
                color: '#919191'
              }
            },
            axisTick: {
              show: true,
              lineStyle: {
                color: '#919191'
              }
            },
            axisLabel: {
              fontSize: 12,
              color: '#919191',
              rotate: 45
            },
            data: this.xAxisSet
          },
          yAxis: {
            type: 'value',
            axisLabel: {
              fontSize: 12,
              color: '#919191'
            },
            axisLine: {
              lineStyle: {
                color: '#919191'
              }
            },
          },
          series: this.DataSet
        }
        // 绘制图表
        this.myChart.setOption(option)
      },
    }
  }
</script>
